import {
	isValidationError,
	type ValidationError,
} from '@atlassian/jira-fetch/src/utils/errors.tsx';
import genericError from './generic-error/index.tsx';
import validationError from './validation-error/index.tsx';

const customFieldEditFailed = (error: Error) =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	isValidationError(error) ? validationError((error as ValidationError).errors) : genericError();

export default customFieldEditFailed;
